module.exports = __webpack_public_path__ + "assets/img/de-ef495efd.png";